import { render, staticRenderFns } from "./PropertyColor.vue?vue&type=template&id=3f4f6514&"
import script from "./PropertyColor.vue?vue&type=script&lang=js&"
export * from "./PropertyColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.FFR503Cp8cB3/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f4f6514')) {
      api.createRecord('3f4f6514', component.options)
    } else {
      api.reload('3f4f6514', component.options)
    }
    module.hot.accept("./PropertyColor.vue?vue&type=template&id=3f4f6514&", function () {
      api.rerender('3f4f6514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Properties/PropertyColor.vue"
export default component.exports